import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import { TitledPaper } from '@dai/components'
import { ActionCodeInfo } from 'firebase/auth'
import HandleVerifyAndChangeEmail from './HandleVerifyAndChangeEmail'
import SendVerifyAndChangeEmail from './SendVerifyAndChangeEmail'

interface VerifyAndChangeEmailProps {
  oobCode: string | null
  signInUrl: string
  isAuthenticated: boolean
  signOut: () => Promise<void>
  verifyAndUpdateEmail: (oobCode: string) => Promise<void>
  checkActionCode: (code: string) => Promise<ActionCodeInfo>
  sendVerifyBeforeUpdateEmail: (
    newEmail: string,
    continueUrl?: string | undefined,
  ) => Promise<void>
}

const VerifyAndChangeEmail: React.FC<VerifyAndChangeEmailProps> = ({
  oobCode,
  signInUrl,
  isAuthenticated,
  signOut,
  verifyAndUpdateEmail,
  checkActionCode,
  sendVerifyBeforeUpdateEmail,
}) => {
  const location = useLocation()
  const navigate = useNavigate()

  return oobCode ? (
    <HandleVerifyAndChangeEmail
      oobCode={oobCode}
      signInUrl={signInUrl}
      verifyAndUpdateEmail={verifyAndUpdateEmail}
      checkActionCode={checkActionCode}
      signOut={signOut}
      sendVerifyBeforeUpdateEmail={sendVerifyBeforeUpdateEmail}
    />
  ) : isAuthenticated ? (
    <TitledPaper title="Update Email" subtitle={'Enter your new email address'}>
      <SendVerifyAndChangeEmail
        onCancel={() =>
          navigate(location.state?.from || '/', { replace: true })
        }
        signInUrl={signInUrl}
        signOut={signOut}
        sendVerifyBeforeUpdateEmail={sendVerifyBeforeUpdateEmail}
      />
    </TitledPaper>
  ) : (
    <TitledPaper
      title="Update Email"
      subtitle={
        'Please sign in to your existing account to update your email address'
      }
    >
      <Button
        variant="contained"
        onClick={() =>
          navigate(signInUrl, {
            state: {
              from: location.pathname + location.search,
            },
            replace: true,
          })
        }
      >
        Sign In
      </Button>
    </TitledPaper>
  )
}

export default VerifyAndChangeEmail
